import { LoaderType } from "../engine/Loaders/LoaderType";

export const BootAssets: Array<{key: string, path: string, type: LoaderType}> = [
  {
    key: "Windows95Spritesheet",
    path: "sprites/Spritesheets/Windows95.json",
    type: LoaderType.PIXI,
  },
  {
    key: "loadingicon",
    path: "sprites/loadingicon.png",
    type: LoaderType.PIXI,
  },
  {
    key: "DesktopBackground",
    path: "sprites/loadscreen.png",
    type: LoaderType.PIXI,
  },
  {
    key: "HospitalCore",
    path: `data/wasm/${
      __PRODUCTION ? "release" : "debug"
    }.js`,
    type: LoaderType.WASM,
  },
];
